export default "/images/3b39a7f84a4f2ac3ee0d134ad793ced9.png";